exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal__body[data-v-d937b5a0] {\n  padding: 20px;\n}\n", ""]);

// exports
